import getObjectPathProperty from './getObjectPathProperty.js';
export function setStatesLoadingList(state, params) {
    if(params.hasOwnProperty('stateLoad') && params.statesLoading && Array.isArray(params.statesLoading)) {
        params.statesLoading.forEach(item => {
            if(getObjectPathProperty(state,item)) {
                const properties = item.split('.');
                let obj = state, lengthProp = properties.length - 1;
                for(let i = 0; i < lengthProp; i++) {
                    if (typeof obj[properties[i]] === 'object') {
                        obj = obj[properties[i]];
                    } else {
                        return;
                    }
                };
                if(obj !== undefined){
                    obj[properties[lengthProp]] = params.stateLoad;
                }
            }
        });
    }
}
